import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { ArrowRight, X } from "lucide-react";

export const PIPELINE = {
  lead:        { label: "Lead",           couleur: "bg-purple-100 text-purple-800 border-purple-300", point: "bg-purple-500" },
  prospect:    { label: "Prospect",       couleur: "bg-blue-100 text-blue-800 border-blue-300",       point: "bg-blue-500" },
  negociation: { label: "En negociation", couleur: "bg-amber-100 text-amber-800 border-amber-300",    point: "bg-amber-500" },
  valide:      { label: "Valide",         couleur: "bg-green-100 text-green-800 border-green-300",    point: "bg-green-500" },
  refuse:      { label: "Refuse",         couleur: "bg-red-100 text-red-800 border-red-300",          point: "bg-red-500" },
};

const SUITE = { lead: "prospect", prospect: "negociation", negociation: "valide" };
const LIBELLE = { lead: "Prendre en charge", prospect: "Passer en negociation", negociation: "Valider" };

export function BadgeStatut({ statut }) {
  const s = PIPELINE[statut] || PIPELINE.prospect;
  return (
    <Badge variant="outline" className={s.couleur + " border font-medium"}>
      <span className={"w-1.5 h-1.5 rounded-full mr-1.5 " + s.point} />
      {s.label}
    </Badge>
  );
}

export default function PipelineStatut({ statut, onChange }) {
  const courant = statut || "prospect";
  const suivant = SUITE[courant];
  const termine = courant === "valide" || courant === "refuse";
  return (
    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
      <BadgeStatut statut={courant} />
      {suivant && (
        <Button size="sm" variant="outline"
          className="h-8 text-xs flex-1 sm:flex-none border-primary text-primary hover:bg-primary hover:text-white"
          onClick={() => onChange(suivant)}>
          {LIBELLE[courant]} <ArrowRight className="w-3 h-3 ml-1" />
        </Button>
      )}
      {!termine && (
        <Button size="sm" variant="ghost" className="h-8 text-xs text-red-500 hover:text-red-700"
          onClick={() => onChange("refuse")}>
          <X className="w-3 h-3 mr-1" /> Refuser
        </Button>
      )}
      {termine && (
        <Button size="sm" variant="ghost" className="h-8 text-xs text-muted-foreground"
          onClick={() => onChange("prospect")}>
          Reouvrir
        </Button>
      )}
    </div>
  );
}
